import { Dispatch, SetStateAction } from 'react';
import { Paths } from '../../../App/routes';

export enum PageLoadConstants {
  NotLoaded,
  Loaded
}

export type LoadContext = {
  [K in Paths]?: PageLoadConstants;
};

export type PageLoadContextType = {
  loadContext: LoadContext;
  setLoadContext: Dispatch<SetStateAction<LoadContext>>;
};
